import { useQuery } from 'react-query';

import { FEATURE_FLAGS_FOR_SELLER } from '@savgroup-front-common/constants';

import useToasts from '../../molecules/NotificationsProvider/ToastsProvider/hooks/useToasts';

import getFeatureFlagsQuery from './getFeatureFlagsQuery';

export const useGetFeatureFlagsQuery = ({
  featureFlag,
  sellerId,
  suspense = true,
  enabled = true,
}: {
  featureFlag: FEATURE_FLAGS_FOR_SELLER[];
  sellerId?: string;
  suspense?: boolean;
  enabled?: boolean;
}): boolean => {
  const { pushErrors } = useToasts();

  const { data } = useQuery(
    ['useGetFeatureFlagsQuery', { sellerId }],
    async () => {
      const response = await getFeatureFlagsQuery({
        sellerId,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return [];
      }

      return response.value;
    },
    { staleTime: Infinity, suspense, enabled },
  );

  return featureFlag.some((flag) =>
    data?.some((feature) => feature.key === flag && feature.value === true),
  );
};
